<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Coverage Quantitative Assessment</h2>
      <div class="close" (click)="cancelImport()"><img src="/assets/img/close-white.svg" alt="" /></div>

      <div class="fields__container">
        <form autocomplete="off"  name="ngCQAForm" #ngForm="ngForm" id="CQAForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Altitude Settings</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Altitude Selection</label>
                    <select id="elevation" name="selectedElevation" [(ngModel)]="selectedElevation" >
                      <option  *ngFor="let el of elevation_info" value="{{el}}">{{ el }}</option>
                    </select>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Area Settings</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Area Selection</label>
                    <select [(ngModel)]="selectedArea" name="selectedArea" (change)="removeSelectAll()">
                      <option [defaultSelected]="" value="FIR">FIR</option>
                      <option value="Country" >Country</option>
                    </select>
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">FIR Selection</label>
                    <select [disabled]="selectedArea == 'Country'" [(ngModel)]="selectedFIR" name="selectedFIR" (change)="removeSelectAll()">
                      <option value="ECAC">ECAC Lower Airspace</option>
                      <option value="ENP">ENP Lower Airspace</option>
                    </select>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <input [disabled]="selectedArea == 'FIR' && selectedFIR == 'ENP'" type="checkbox" name="ECACArea" id="selectAll" [(ngModel)]="selectAllECAC"/>
                  <label for="">ECAC Area</label>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="table-fields">
                <label> Area Selection </label>
                <div style="overflow-y: scroll; height: 237px;">
                  <table *ngIf="selectedArea == 'FIR' && selectedFIR == 'ECAC'" >
                    <caption>
                    </caption>
                    <tbody>
                      <tr mdbTableCol *ngFor="let el of areasFIRECACTable; let i = index">
                        <td>
                          <input id="chk_{{i}}" name="{{ el }}"
                            type="checkbox" [disabled]="selectAllECAC ? true : false" [checked]="selectAllECAC ? true : false" ngModel/>
                        </td>
                        <td>{{ el }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <table *ngIf="selectedArea == 'FIR' && selectedFIR == 'ENP'" >
                    <caption>
                    </caption>
                    <tbody>
                      <tr mdbTableCol *ngFor="let el of areasFIRENPTable; let i = index">
                        <td>
                          <input id="chk_{{i}}" name="{{el}}" type="checkbox" ngModel/>
                        </td>
                        <td>{{ el }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <table *ngIf="selectedArea == 'Country' ">
                    <caption>
                    </caption>
                    <tbody>
                      <tr mdbTableCol *ngFor="let el of areasCountryTable; let i = index">
                        <td>
                          <input id="chk_{{i}}" name="{{el}}"
                           type="checkbox" [checked]="selectAllECAC ? true : false" [disabled]="selectAllECAC ? true : false"  ngModel/>
                        </td>
                        <td>{{ el }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>

          </div>
          <div class="fields__btn">
            <button type="submit" (click)="performOk(ngForm)" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'"  [disabled]="!ngForm.form.valid">
              Ok
            </button>
            <button class="gray" (click)="cancelImport()">Cancel</button>
          </div>

        </form>

      </div>


    </div>
  </div>
</div>
